import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Paper, Typography } from "@mui/material";
import axios from "axios";
import { localeTextVietnamese } from "../../utils/localeText-vn";
import { formatDate } from "../../utils/CurrencyFormat";

export default function CustomerAdminPage() {
  const [rows, setRows] = React.useState([]);
  const [totalItems, setTotalItems] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  // setting collumn
  const columns = [
    { field: "index", headerName: "STT", width: 100 },
    { field: "visibleName", headerName: "Tên hiển thị", flex: 3 },
    { field: "fullName", headerName: "Họ và tên", flex: 3 },
    { field: "username", headerName: "Tên tài khoản", flex: 3 },
    { field: "email", headerName: "Email", flex: 3 },
    { field: "phone", headerName: "Số điện thoại", flex: 3 },
    { field: "orderCount", headerName: "Số đơn hàng", flex: 3 },
  ];

  React.useEffect(() => {
    getData();
  }, [paginationModel]);

  const getData = () => {
    axios
      .get(`/api/v1/customers`, {
        params: {
          page: paginationModel.page,
          limit: paginationModel.pageSize,
          paginationAdmin: true,
        },
      })
      .then((res) => {
        setRows(res.data.customers);
        setTotalItems(res.data.totalItems);
      })
      .catch((err) => console.log(err));
  };

  const rowsWithIndex = rows.map((row, index) => ({
    index: index + 1,
    ...row,
    parentId: row.parentId == 0 ? "" : row.parentId,
  }));

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Quản lý người đăng ký
      </Typography>
      <Box
        sx={{ marginBottom: 2, display: "flex", justifyContent: "end" }}
      ></Box>
      <Paper sx={{ height: 730, width: "100%" }}>
        <DataGrid
          rows={rowsWithIndex}
          columns={columns}
          rowHeight={150}
          rowCount={totalItems}
          pagination
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) =>
            setPaginationModel(newPaginationModel)
          }
          initialState={{
            pagination: {
              paginationModel: paginationModel,
            },
          }}
          pageSizeOptions={[5, 10]}
          // checkboxSelection
          disableRowSelectionOnClick
          localeText={localeTextVietnamese}
          sx={{
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                marginBottom: 0,
              },
          }}
        />
      </Paper>
    </Box>
  );
}
